const langPackLocalVersion = 6;export default langPackLocalVersion;
